export default "__VITE_PUBLIC_ASSET__8870334e__"